import { ImportWizardFile } from "@/app/dtos/import-wizard/import-wizard.dto";
import { CardComponent } from "@/app/shared/card/card-wrapper/card.component";
import { CommonModule } from "@angular/common";
import { Component, computed, input, output } from "@angular/core";
import { ImportWizardGeoSpatialService } from "../../../import-wizard-geospatial.service";
import { ImportWizardStep, ImportWizardStorage } from "../../../../../import-wizard.storage";
import { ImportWizardService } from "../../../../../import-wizard.service";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "app-geospatial-feature-card",
    template: `
        <app-card>
            <span class="card-title">{{ featureName() }}</span>
            <div class="button-container">
                <button (click)="handleVisualizeClick()">Visualizar</button>
                <button (click)="handleDeleteClick()">Deletar</button>
            </div>
        </app-card>
    `,
    styleUrls: ["./import-wizard-geospatial-feature-card.component.scss"],
    imports: [
        CommonModule,
        CardComponent
    ],
})
export class ImportWizardGeospatialFeatureCardComponent {

    importWizardFileDetail = input<ImportWizardFile>();

    deletedFile = output<ImportWizardFile>();

    featureName = computed(() => {
        const filename = this.importWizardFileDetail()?.filename;
        if (!filename) return '';
        return filename
            .split('.')[0];
    });

    constructor(
        private toastrService: ToastrService,
        private importWizardGeoSpatialService: ImportWizardGeoSpatialService,
        private importWizardService: ImportWizardService,
        private importWizardStorage: ImportWizardStorage
    ) {}

    async handleVisualizeClick() {
        const file = this.importWizardFileDetail();
        if (!file) return;

        this.importWizardStorage.setId(file.job_id);
        this.importWizardStorage.setFilename(file.filename);

        await this.importWizardGeoSpatialService.useGetImportFile();

        this.importWizardStorage.refreshMap();

        this.importWizardStorage.setStep(ImportWizardStep.PREVIEW);
        this.importWizardStorage.setInViewStep(ImportWizardStep.PREVIEW);
    }

    handleDeleteClick() {
        this.importWizardService.deleteFileFromImportWizard(this.importWizardFileDetail()!.id).subscribe({ 
            next: () => {
                this.deletedFile.emit(this.importWizardFileDetail()!);
                this.toastrService.success('Camada deletada com sucesso!', '', { closeButton: true });
            },
            error: () => {
                this.toastrService.error('Erro ao deletar camada!', '', { closeButton: true });
            }
        });
    }
}